import Footer from "../Common/Footer";
import Header from "../Common/Header";
import {Link} from 'react-router-dom';

import React, { useEffect } from "react";

function About() {

  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    return (
        <>
        <Header/>
        <div
          className="breadcumb-wrapper" style={{backgroundImage:"url(" + "assets/img/bg/breadcumb-bg.jpg" + ")", backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize:'cover'}}
      
        >
          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">About Us</h1>
            
            </div>
          </div>
        </div>
    
        <div className="space">
          <div className="container">
            <div className="row align-items-center mb-40">
              <div className="col-xl-7 mb-40 mb-xl-0">
                <div className="img-box1">
                  <img src="assets/img/normal/cow-farm.png" alt="About" style={{width:'100%'}} />
                </div>
              </div>
              <div className="col-xl-5 text-center text-xl-start">
                <div className="title-area mb-34">
                  <span className="sub-title">
                    <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                    About Company
                  </span>
                  <h2 className="sec-title">
                  We promise for better health with better taste

                  </h2>
                  <p className="sec-desc">
                Quality dairy products made with care, delivered with trust. Every product crafted to bring health and happiness to your home.
                  </p>
                  <p className="sec-desc">
                Since 2002, our dairy brand has worked closely with local Indian farmers to bring the freshest, purest milk and dairy products directly to your home.</p>
  <p className="sec-desc">
Mr. Sandeep, the Director of Shvetdhara started his journey as the retailer of milk products in 13, June 2002. This initiative played a significant role that inspired him to start a dairy product plant of his own. Later in 2009, he installed his own setup of Paneer Plant as “New Kamboj Dairy” which proved to be a great success.
                  </p>
                </div>
              
              </div>

        
            </div>

            <div className="row">
                    <div className="col-xl-12">
                <p className="sec-desc">
                   This plant infused employment and growth in the private sector. After ample time Mr. Sandeep realized that the quality of milk was degrading in the city with time. So he catered milk to the city by instigating a new project called ‘Shvetdhara Dairy Food Private Limited’ on 12 Feb, 2016. ‘Shvet’ is inspired by the name “Shvet Kranti” which comes from a freedom movement started by Mr. Verghese Kurien. Shvet also means purity in its best form. Whereas, ‘Dhara’ is the stream, the positive stream needed to flourish in the market.
                </p>
                </div>
                 <div className="col-xl-6">
                  <div className="mb-40">
                  <div className="about-feature-wrap">
                    <div className="about-feature">
                      <div className="box-icon">
                        <img src="assets/img/icon/about_feature_1.svg" alt="Icon" />
                      </div>
                      <h3 className="box-title">100% Pure Products</h3>
                    </div>
                    <div className="about-feature">
                      <div className="box-icon">
                        <img src="assets/img/icon/about_feature_2.svg" alt="Icon" />
                      </div>
                      <h3 className="box-title">100% Quality Products</h3>
                    </div>
                  </div>
                </div>
               
              </div>
              </div>
            </div>
          </div>
       
        <section className="space">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                Why Choose Shvetdhara?

              </span>
              <h2 className="sec-title">Easy our 4 step work</h2>
            </div>
            <div className="process-card-wrap">
              <div className="process-card">
                <div className="box-number">01</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_1.svg" alt="Icon" />
                </div>
                <h3 className="box-title">Strict Quality Control
                </h3>
              
              </div>
              <div className="process-card">
                <div className="box-number">02</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_2.svg" alt="Icon" />
                </div>
                <h3 className="box-title">Innovation & Sustainability
                </h3>
                
              </div>
              <div className="process-card">
                <div className="box-number">03</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_3.svg" alt="Icon" />
                </div>
                <h3 className="box-title">100% Fresh & Pure
                </h3>
             
              </div>
              <div className="process-card">
                <div className="box-number">04</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_4.svg" alt="Icon" />
                </div>
                <h3 className="box-title">Wide Product Range
                </h3>
              
              </div>
            </div>
          </div>
        </section>


      
  
  <section className="" style={{backgroundImage:"url(" + "assets/img/bg/cta_bg_1.png" + ")", backgroundRepeat:'no-repeat'}}>
    <div className="container text-center space">
      <div className="row justify-content-center">
        <div className="col-xxl-9 col-lg-10">
          <h2 className="fs-60 sec-title text-white">
          Discover Services Come & Feel Our Dairy

          </h2>
          
          <div className="btn-group">
          
         <Link to="/contact" className="ot-btn style4">
              Contact Us
              <i className="fas fa-chevrons-right ms-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>


        <Footer />
      </>
      
    );
  }
  
  export default About;
  